import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const BetslipOptionsActionTypes = Object.freeze({
  ADD_BET_TO_FAVORITES: 'BETSLIP_OPTIONS:ADD_BET_TO_FAVORITES',
  REMOVE_BET_FROM_FAVORITES: 'BETSLIP_OPTIONS:REMOVE_BET_FROM_FAVORITES',
  HIDE_BET: 'BETSLIP_OPTIONS:HIDE_BET',
  REMOVE_HIDE_BET: 'BETSLIP_OPTIONS:REMOVE_HIDE_BET',
});

export type BetslipOptionsActionType = ObjectValuesUnionType<typeof BetslipOptionsActionTypes>;
